import * as React from 'react'
import * as classNames from 'classnames'
import { DAYS_OF_WEEK } from 'src/state/constants'
import { IWorkingHoursItem } from 'src/types'
import WorkingTime from '../services/edit/WorkingTime'
import DaysOfWeek from '../services/edit/working-hours/DaysOfWeek'
import ContextMenu from '../ui/ContextMenu'
import TrashIcon from '../icons/ui/Trash'
import { IDriverSchedule } from './DriverViewSchedule'

interface IDriverWorkingHoursItemProps {
  index: number
  workingHoursItem: IDriverSchedule
  errorDays: string[]
  onRemoveClick: (index: number) => void
  onSetFrom: (index: number, from: string, until: string) => void
  onSetUntil: (index: number, from: string, until: string) => void
  onSetDays: (index: number, days: string[]) => void
}

interface IEditDaysOfWeek {
  index: number
  days: string[]
  errorDays: string[]
  onDayClick: (value: string) => void
}

const DriverWorkingHoursItem = (props: IDriverWorkingHoursItemProps) => {
  const {
    index,
    workingHoursItem,
    workingHoursItem: { days, from, until },
    errorDays,
    onRemoveClick,
    onSetDays,
    onSetFrom,
    onSetUntil
  } = props

  const [tempFrom, setTempFrom] = React.useState<string>('')
  const [tempUntil, setTempUntil] = React.useState<string>('')

  React.useEffect(() => {
    if (tempFrom !== '' && tempUntil !== '') {
      onSetFrom(index, tempFrom, tempUntil)
    }
  }, [tempFrom])

  React.useEffect(() => {
    if (tempFrom !== '' && tempUntil !== '') {
      onSetUntil(index, tempFrom, tempUntil)
    }
  }, [tempUntil])

  const removeDay = (days: string[], day: string): string[] => {
    const position = days.indexOf(day)
    return [...days.slice(0, position), ...days.slice(position + 1)]
  }

  const addDay = (days: string[], day: string): string[] => {
    return [...days, day]
  }

  const handleDayClick = (day: string) => {
    const updatedDays = days.includes(day) ? removeDay(days, day) : addDay(days, day)
    onSetDays(index, updatedDays)
  }

  const handleTimeSet = (type: string, time: string) => {
    type === 'from' ? setTempFrom(time) : setTempUntil(time)
  }

  const handleRemoveClick = () => {
    onRemoveClick(index)
  }

  return (
    <div className='mt1'>
      <div className='flex flex-row items-start p3 border-light-grey4 rounded' style={{ columnGap: '15px' }}>
        <div className='pr3'>
          <div className='h5 font-dark-grey'>From - Until</div>
          <div className='full-width-datepicker'>
            <WorkingTime
              from={from}
              type={errorDays.length > 0 ? 'error' : 'long'}
              until={until}
              onTimeSet={handleTimeSet}
            />
          </div>
        </div>
        <div>
          <div className='h5 font-dark-grey'>On these days</div>
          <div className='mt02 full-width-datepicker'>
            <EditDaysOfWeek
              days={workingHoursItem.days}
              index={index}
              onDayClick={handleDayClick}
              errorDays={errorDays}
            />
          </div>
        </div>
        <div className='mt1 pt2 self-center'>
          <ContextMenu>
            <div className='MenuItem flex items-center cursor--pointer' onClick={handleRemoveClick}>
              <TrashIcon className='icon--16x16 svg-stroke-grey3 mr1' />
              <span className='font-dark-grey h5'>Remove</span>
            </div>
          </ContextMenu>
        </div>
      </div>
      {errorDays.length > 0 && (
        <div className='h6 font-red mt1'>This schedule is overlapping with other schedules and cannot be saved.</div>
      )}
    </div>
  )
}

const EditDaysOfWeek = (props: IEditDaysOfWeek) => {
  const { days, index, errorDays, onDayClick } = props

  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

  const daysOfWeekShortcut = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

  const handleDayClick = (day: string) => () => {
    onDayClick(day)
  }

  return (
    <div className='flex'>
      {daysOfWeek.map((it, dayIndex) => {
        const classes = classNames('day-of-week p1 cursor--pointer mt1', {
          'bg-light-grey2 font-grey2': !days.includes(it),
          'bg-green font-white': days.includes(it) && !errorDays.includes(it),
          'bg-red font-white': errorDays.includes(it)
        })

        return (
          <div className={classes} key={`${it}-${index}`} onClick={handleDayClick(it)}>
            {daysOfWeekShortcut[dayIndex]}
          </div>
        )
      })}
    </div>
  )
}

export default DriverWorkingHoursItem



// WEBPACK FOOTER //
// ./src/components/drivers/DriverWorkingHoursItem.tsx